import { IconButton, Tooltip } from '@mui/material';
import { useVideoStyles } from './styles';
import clsx from 'clsx';

export type ControlButtonActivityStatus = {
  icon: React.ReactNode;
  tooltipTitle: string;
  className?: string;
};

export type ControlButtonProps = {
  isActive: boolean;
  onToggleActive: () => void;
  enabled: ControlButtonActivityStatus;
  disabled: ControlButtonActivityStatus;
  disableToggle?: boolean;
};

export const ControlButton: React.VFC<ControlButtonProps> = ({ isActive, onToggleActive, enabled, disabled, disableToggle }) => {
  const { classes } = useVideoStyles({}, { props: { classes: { enabledControlButton: enabled?.className, disabledControlButton: disabled?.className } } });

  return (
    <Tooltip
      placement="top"
      title={isActive ? enabled.tooltipTitle : disabled.tooltipTitle}
      className={classes.buttonTooltip}
    >
      <IconButton
        className={clsx(classes.controlButton, {
          [classes.disableToggle]: disableToggle,
          [classes.disabledControlButton]: !isActive,
          [classes.enabledControlButton]: isActive,
        })}
        onClick={disableToggle ? undefined : onToggleActive}
        disableRipple
      >
        {isActive ? enabled.icon : disabled.icon}
      </IconButton>
    </Tooltip>
  );
};
